// Valou Types - Integration mit GoodWork Crafting Valoustyling

// Die 6 Valou-Bereiche (identisch mit Crafting App)
export type ValouAreaId =
  | 'privatesLeben'
  | 'persoenlichkeitSkills'
  | 'taetigkeit'
  | 'stilWirkung'
  | 'ressourcenMittel'
  | 'gesundheit';

// Valou-Bereich Konfiguration mit Farben aus Crafting App
export interface ValouAreaConfig {
  id: ValouAreaId;
  name: string;
  shortName: string;
  icon: string;
  color: string;
  description: string;
}

// Die 6 Valou-Bereiche mit ihren Eigenschaften
export const VALOU_AREAS: ValouAreaConfig[] = [
  {
    id: 'privatesLeben',
    name: 'Privates Leben',
    shortName: 'Privat',
    icon: '🏠',
    color: '#7CB342',
    description: 'Work-Life-Balance, Zuhause, Beziehungen',
  },
  {
    id: 'persoenlichkeitSkills',
    name: 'Persoenlichkeit & Skills',
    shortName: 'Persoenlichkeit',
    icon: '⭐',
    color: '#FFC107',
    description: 'Wer du bist, deine Staerken',
  },
  {
    id: 'taetigkeit',
    name: 'Arbeit & Taetigkeit',
    shortName: 'Arbeit',
    icon: '💼',
    color: '#A1887F',
    description: 'Arbeitsumfeld, Aufgaben',
  },
  {
    id: 'stilWirkung',
    name: 'Stil & Wirkung',
    shortName: 'Stil',
    icon: '✨',
    color: '#EC407A',
    description: 'Wie du wirkst und auftrittst',
  },
  {
    id: 'ressourcenMittel',
    name: 'Ressourcen & Mittel',
    shortName: 'Ressourcen',
    icon: '🔗',
    color: '#42A5F5',
    description: 'Netzwerk, Finanzen, Tools',
  },
  {
    id: 'gesundheit',
    name: 'Gesundheit',
    shortName: 'Gesundheit',
    icon: '💚',
    color: '#EF5350',
    description: 'Koerper, Geist, Erholung',
  },
];

// Helper: Get Valou Area Config by ID
export function getValouAreaConfig(areaId: ValouAreaId): ValouAreaConfig | undefined {
  return VALOU_AREAS.find((area) => area.id === areaId);
}

// User Valou-Profil (aus Crafting App gelesen)
export interface ValouUserDataEntry {
  stylingSatz: string;
  vorlieben: string[];
  abneigungen: string[];
  mustHaves: string[];
  noGos: string[];
  mood?: number; // 1-10
}

export type ValouProfile = Partial<Record<ValouAreaId, ValouUserDataEntry>>;

// Match Score fuer Personalisierung
export interface PlaceMatchScore {
  placeId: string;
  totalScore: number;
  matchedAreas: ValouAreaId[];
  improvementPotential: ValouAreaId[];
}
